import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ApproachSection = () => {
  return (
    <section
      id="approach"
      data-testid="approach-section"
      className="py-24 md:py-32 bg-cream"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-x-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <p className="text-xs uppercase tracking-[0.2em] text-gold font-sans font-semibold mb-4">
              Notre Savoir-Faire Différenciant
            </p>
            <h2
              className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal tracking-tight text-forest mb-6"
              data-testid="approach-headline"
            >
              Le foncier forestier comme levier de création de valeur
            </h2>
            <div className="section-divider mb-8" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-7"
          >
            <p className="font-sans text-base md:text-lg text-gray-700 leading-relaxed mb-6">
              Lorsque des parcelles sont morcelées, isolées ou issues de successions complexes, leur potentiel peut être fortement limité.
            </p>
            <p className="font-sans text-base md:text-lg text-gray-700 leading-relaxed mb-8">
              <strong className="text-forest">Sylva Invest recherche des solutions d'acquisition, de transaction, d'échange ou de regroupement</strong> afin de recomposer des ensembles forestiers plus cohérents, plus lisibles et plus facilement valorisables.
            </p>
            <Link
              to="/remembrement-forestier"
              className="inline-flex items-center font-sans font-medium text-forest hover:text-gold transition-colors group"
            >
              Découvrir notre approche du remembrement
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
        </div>

        {/* Visual element */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.4 }}
          className="mt-16 relative h-64 md:h-96 overflow-hidden"
        >
          <img
            src="https://images.unsplash.com/photo-1637649209301-143859e93c66?q=80&w=2000&auto=format&fit=crop"
            alt="Forêt de feuillus en Nouvelle-Aquitaine, exemple de patrimoine forestier à regrouper"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-forest/30 to-transparent" />
        </motion.div>
      </div>
    </section>
  );
};

export default ApproachSection;
